// extracted by mini-css-extract-plugin
export default {"card":"V8-z"};